// extracted by mini-css-extract-plugin
export default {"noPaddingBottom":"auj1yt","external":"buj1yt","block":"cuj1yt"};